import styled from 'styled-components';

export const Container = styled.div<{ headerHeight: string }>`
  display: flex;
  align-items: center;
  background: #f5f5f5;
  justify-content: center;
  padding-top: ${(props) => props.headerHeight};
`;

export const LoadingContainer = styled.div`
  display: flex;
  height: 100vh;
  align-items: center;
  background: #f5f5f5;
  justify-content: center;
`;
